import React from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { RiHandCoinFill } from "react-icons/ri";
import { MdOutlineTableRestaurant } from "react-icons/md"
import { FaTruck } from "react-icons/fa"
import { GiFilmProjector } from "react-icons/gi"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { IconButton, } from "components"
// import { clearDeliveryInfo, clearOrderTableNumber } from "@redux"
import classes from "./FoodsFloatTablesButton.module.scss"

const FoodsFloatTablesButton = () => {
  const i18n = useTranslation()[1]

  const history = useHistory()

  const tableNumber =
    useSelector(state => state.order.tableNumber)

  const kitchenTables =
    useSelector(state => state.kitchenTables)
      .filter(kt => kt.available)

  const deliveryType =
    useSelector(state =>
      state.deliveryInfo.deliveryType
    )

  // const editMode =
  //   useSelector(state =>
  //     state.orderForEditDetails !== null
  //   )

  const handleGoToKitchenTables = () => {
    history.push(
      "/kitchen-tables",
      {
        previousPage: "/foods"
      }
    )
  }

  // const handleClear = (e) => {
  //   e.stopPropagation()

  //   dispatch(clearDeliveryInfo())

  //   dispatch(clearOrderTableNumber())
  // }

  const numberOfReadyTables =
    kitchenTables.filter(kt =>
      kt.status === "ready"
    ).length

  const isDeliverySelected =
    tableNumber !== "" ||
    deliveryType !== "dineIn"

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (isDeliverySelected) {
    return (
      <div
        onClick={handleGoToKitchenTables}
        className={clsx(
          classes["tables-number"],
          isLtr && classes["tables-number-ltr"]
        )}
      >
        {/* {
          !editMode &&
          <IconButton
            icon={MdClose}
            color="white"
            size={16}
            className={classes["close"]}
            onClick={handleClear}
          />
        } */}
        {
          deliveryType === "dineIn" &&
          <span className={classes["tableNumberText"]}>
            {tableNumber}
          </span>
        }
        {
          deliveryType === "selfPickup" &&
          <RiHandCoinFill
            color="white"
            size={18}
          />
        }
        {
          deliveryType === "delivery" &&
          <FaTruck
            color="white"
            size={18}
          />
        }
        {
          deliveryType === "cinema" &&
          <GiFilmProjector
            color="white"
            size={22}
          />
        }
      </div>
    )
  }

  return (
    <IconButton
      icon={MdOutlineTableRestaurant}
      color="white"
      badge={numberOfReadyTables}
      size={30}
      className={clsx(
        classes["tables-button"],
        isLtr && classes["tables-button-ltr"]
      )}
      onClick={handleGoToKitchenTables}
    />
  )
}

export default React.memo(FoodsFloatTablesButton)